<template>
  <div id="app" class="" v-if="loaded">
    <Navbar />
    
    <router-view :key="$route.path" />
    
    <br>
    <!--<footer style="background-color: #005482" class="text-white w-full text-center border-t pt-2 h-12 absolute bottom-0">
      Platinum POS. All Rights Reserved © 2023
    </footer> -->
    
  </div>
  <Loader v-else />
</template>

<script>
import Navbar from "./components/Navbar";
//import Sidebar from "./components/Sidebar";
import Loader from "./components/Loader";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { Navbar, Loader},
  data() {
    return {
      loaded: false,
    };
  },
  beforeCreate() {
    this.$auth.onAuthStateChanged(async (user) => {
      if (!user) {
        this.$nextTick(() => (this.loaded = true));
      }
      if (user && !this.isLoggedIn) {
        await this.setCurrentUser(user);
      }

      if (user) {
        const userDoc = this.$db.collection("users").doc(user.uid);

        userDoc.get().then(async (doc) => {
          if (doc.exists) {
            const data = doc.data();
            await this.setOnboarded(data.onboardingComplete);
            await this.setCurrentUserData(data);
            if (!data.onboardingComplete) {
              this.$router.push(
                {
                  name: "onboarding",
                },
                () => this.$nextTick(() => (this.loaded = true))
              );
            } else if (this.$route.query.from) {
              this.$router.push(
                {
                  path: this.$route.query.from,
                },
                () => this.$nextTick(() => (this.loaded = true))
              );
            } else {
              this.loaded = true;
            }
          } else {
            this.loaded = true;
          }
        });
      }
    });
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
  },
  methods: {
    ...mapActions(["setCurrentUser", "setOnboarded", "setCurrentUserData"]),
  },
};
</script>
<style scoped>

</style>

